import Button from "@/common/components/Button";
import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import { ArrowBigRightIcon, CarFrontIcon, UserRoundIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { MaintenaceWorkflowData } from "../types/maintenanceWorkflows.type";
import { maintenanceWorkflowStatus } from "../constants/maintenanceWorkflowsStatus.constant";

export class MaintenanceWorkflowsTransformer {

  static tableTransformer() {
    return (workflows: MaintenaceWorkflowData[]) => {
      return workflows.map((workflow) => {
        return {
          status: maintenanceWorkflowStatus[workflow.status] || workflow.status,
          observations: workflow.observations,
          equipment: (
            <ImageWithDisplayName
              placeholderIcon={CarFrontIcon}
              imageUrl={workflow.equipment?.photos?.[0]?.url}
              displayName={workflow.equipment?.field_for_display_value}
            />
          ),
          branch: workflow.equipment?.branch?.display_name,
          creator: workflow.creator ? (
            <ImageWithDisplayName
              placeholderIcon={UserRoundIcon}
              imageUrl={workflow.creator?.profile_picture?.url}
              displayName={workflow.creator?.full_name}
            />
          ) : '--',
          actions: (
            <Link to={workflow.id}>
              <Button
                variant="link-white"
                className="w-full"
                operationKlassToCheckPermission="Client::Maintenance::Workflows::Show"
              >
                <ArrowBigRightIcon />
              </Button>
            </Link>
          ),
        };
      });
    }
  }

}
